import { defineComponent as _defineComponent } from 'vue'
import type { WpProject } from "@/stores/api";


export default /*#__PURE__*/_defineComponent({
  props: {
    estate: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();



const formatPrice = (value: number) => {
    let val = (value / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const __returned__ = { formatPrice }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})